import { LocalizedTypography } from 'components/Localization/LocalizedTypography'
import {
  ProjectStateAsString,
  ProjectStatus,
} from 'controllers/Project/ProjectStateMachine'
import { LightTooltip } from './LightTooltip'
import { useCancelledStateItem } from './useCancelledStateItem'
import { useProjectStateItem } from './useProjectStateItem'

const projectState = ProjectStatus.CANCELLED

export const CancelledState = () => {
  const {
    getStateTranslationKey,
    stateItemIsCurrent,
    getBaseClassName,
    changeStatus,
    SavingComponent,
  } = useProjectStateItem(projectState)

  const { canChangeToCancelledState, Errors, errorStyle } =
    useCancelledStateItem()

  const handleClick = () => {
    if (canChangeToCancelledState) {
      changeStatus(ProjectStateAsString.DEFINING)
    }
  }

  return (
    <LightTooltip title={canChangeToCancelledState ? '' : <Errors />}>
      <li style={errorStyle} className={getBaseClassName} onClick={handleClick}>
        <LocalizedTypography
          translationKey={getStateTranslationKey()}
          variant="body2"
        />

        <SavingComponent />
      </li>
    </LightTooltip>
  )
}
